import { Entity } from '@models/_base.model';

export class AdminStats extends Entity {
  usersTotal: number;
  usersDeactivated: number;
  usersActive: number;
}
